module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_25-49af690124b83a8cae856bd9fd91ce9b.jpg";